const keys = [
    'href',
    'origin',
    'protocol',
    'username',
    'password',
    'host',
    'hostname',
    'port',
    'pathname',
    'search',
];

const parseUrl = (url = '') => {
    /*eslint-disable*/
    const match = url.match(
        /^(?:(?:(([^:\/#\?]+:)?(?:(?:\/\/)(?:(?:(?:([^:@\/#\?]+)(?:\:([^:@\/#\?]*))?)@)?(([^:\/#\?\]\[]+|\[[^\/\]@#?]+\])(?:\:([0-9]+))?))?)?)?((?:\/?(?:[^\/\?#]+\/+)*)(?:[^\?#]*)))?(\?[^#]+)?)(#.*)?/,
    );
    /*eslint-enable*/
    if (!match) {
        return {};
    }

    const result = {};

    keys.forEach((key, index) => {
        result[key] = match[index];
    });
    return result;
};

export default parseUrl;
